// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2020-12-18 14:27:29 +0100 (Fri, 18 Dec 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: a.hesse $
//  Revision  : $Rev: 115776 $
//  Purpose   : utility functions for date handling
// =============================================================================
// ---Third-party imports
import {formatISO, subDays} from 'date-fns'

// ---Framework imports
import {dict} from 'ldash'

// ---Exports
export const isoToday = () => formatISO(new Date(), {representation: 'date'})
export const isoDate = d => formatISO(d, {representation: 'date'})

const granularities = ['year', 'quart', 'month', 'week', 'day']
export const interval2granularity = dict(granularities.map(g => [g, g[0].toUpperCase()]))
export const granularity2interval = dict(granularities.map(g => [g[0].toUpperCase(), g]))

// limits for granularities
// attention: should be ascending sorted
export const GranularityStrategy = {
  D: null,
  W: null,
  M: null,
  Q: null,
  Y: null,
}
